/* eslint-disable */
import React, {useEffect, useState} from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Divider,
    Grid,
    Button,
    Slide,
    InputLabel,
    TextField,
    DialogActions,
} from "@mui/material"
import {useDataParams} from "../hooks/useDataParams";
import {useDispatch, useSelector} from "react-redux";
import {$crud} from "../services/CrudFactory";
import {Visibility} from "@mui/icons-material";


export const TagsModal = (props) => {
    const dispatch = useDispatch();
    const {params, handleChange, setParams} = useDataParams();
    let branchId =  localStorage.getItem("branchInfo");
    let branchInfo = JSON.parse(branchId);
    const {open, onClose} = props;

    // console.log(params, "--------params");

    const cancel = () => {
        onClose();
        setParams({});
    }

    const handleSubmit = async() =>{
        try {
            dispatch({
                type: "LOADER",
                loader: true
            });
            const {type, message} = await $crud.post("create/web/sub-tag", {...params, branchId:branchInfo?.id});
            
            dispatch({
                type: "SNACKBAR",
                snackBar: {type, message},
            });
            props.onSave();
            cancel();
        } catch (e) {
            dispatch({
                type: "SNACKBAR",
                snackBar: {type: "error", message: e.message}
            })
        } finally {
            dispatch({
                type: "LOADER",
                loader: false
            });
        }
    }
    // const retrieveUrl = async () => {
    //     try {
    //         dispatch({
    //             type: "LOADER",
    //             loader: true
    //         });
    //         const {data} = await $crud.retrieve("web/server-user-url",{id:props?.id});
    //         return data;
    //     } catch (e) {
    //         dispatch({
    //             type: "SNACKBAR",
    //             snackBar: {type: "error", message: e.message}
    //         })
    //     } finally {
    //         dispatch({
    //             type: "LOADER",
    //             loader: false
    //         });
    //     }
    // }

    // const handleSubmit = async () =>{
    //     try {
    //         dispatch({
    //             type: "LOADER",
    //             loader: true
    //         });
    //         const {type, message, data} = await $crud.post(
    //             !props?.id ? "create/web/server-user-url" : "update/web/server-user-url",{
    //                 ...params
    //             }
    //         );
    //
    //         dispatch({
    //             type: "SNACKBAR",
    //             snackBar: {type, message},
    //         });
    //         // retrieveUsers().then(res=>{
    //         //     dispatch(users(res.users))
    //         // })
    //         onSubmit(data);
    //         cancel();
    //     } catch (e) {
    //         dispatch({
    //             type: "SNACKBAR",
    //             snackBar: {type: "error", message: e.message}
    //         })
    //     } finally {
    //         dispatch({
    //             type: "LOADER",
    //             loader: false
    //         });
    //     }
    // }

    return (
        <Dialog maxWidth={"xs"} TransitionProps={
            {
                onEnter: () => {
                }
            }
        } TransitionComponent={Slide} fullWidth open={open}>
            <div className="tableHeader-color">
                <DialogTitle>Tags</DialogTitle>
                <Divider/>
                <DialogContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Grid container justifyContent="space-between" alignItems="center">
                                <InputLabel className="mb-1">Tag Name</InputLabel>
                            </Grid>
                            <TextField
                                required
                                size="small"
                                value={params?.name || ""}
                                onChange={(e) => handleChange("name", e.target.value)}
                                fullWidth
                            />
                        </Grid>
                        
                    </Grid>

                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={cancel} color="primary" size="small">Cancel</Button>
                    <Button className="ms-2" onClick={()=>{handleSubmit(params)}} variant="contained" color="primary" size="small">Submit</Button>
                </DialogActions>
            </div>
        </Dialog>
    );
};
